import { PublicClientApplication } from '@azure/msal-browser';
// routes
import { paths } from 'src/routes/paths';
// config
import { AZURE_STUDENT_CLIENT_ID, AZURE_FVSD_AUTHORITY } from 'src/config-global';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

// Student sign-in (#602) uses its own single-tenant app registration, only
// assigned to the All Students group. It signs in with a popup so it never
// shares the staff app's redirect-hash handling on the login page.

export const studentLoginEnabled = Boolean(AZURE_STUDENT_CLIENT_ID);

let msalInstance = null;

const studentMsal = async () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication({
      auth: {
        clientId: AZURE_STUDENT_CLIENT_ID,
        redirectUri: paths.auth.jwt.login,
        authority: AZURE_FVSD_AUTHORITY,
        navigateToLoginRequestUrl: false,
      },
    });
    await msalInstance.initialize();
  }
  return msalInstance;
};

/**
 * Sign in with the student app and return the Microsoft ID token, for the
 * server's /login/microsoft to verify.
 * @returns {Promise<string>}
 */
export async function getStudentIdToken() {
  const msal = await studentMsal();
  const response = await msal.loginPopup({
    scopes: ['openid', 'profile', 'email', 'User.Read'],
    prompt: 'select_account',
  });
  return response.idToken;
}

export const isStudentUser = (user) =>
  Array.isArray(user?.roles) && user.roles.includes(ROLES.USER_ROLE_STUDENT);

// The only signed-in pages a student session may open; everything else sends
// them to STUDENT_HOME. Mirrors the server's student session gate.
export const STUDENT_PATHS = [paths.studentDashboard.root];
export const STUDENT_HOME = paths.studentDashboard.root;

export const studentMayOpen = (pathname) =>
  STUDENT_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
